import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@styles/components/slider.css";
import { on, fire } from "delegated-events";
import pillList from "@scripts/components/pill-list";

const handleScollers = () => {
  document.querySelectorAll(".element-businessunitdivisions").forEach((el) => {
    const divisionsList = el.querySelector(".divisions-list");
    const prev = el.querySelector(".divisions-list-prev");
    const next = el.querySelector(".divisions-list-next");

    prev.disabled = false;
    next.disabled = false;

    if (divisionsList.scrollWidth > divisionsList.clientWidth) {
      if (divisionsList.scrollLeft === 0) {
        prev.disabled = true;
      }

      if (Math.ceil(divisionsList.scrollLeft) + divisionsList.clientWidth >= divisionsList.scrollWidth) {
        next.disabled = true;
      }
    } else {
      prev.disabled = true;
      next.disabled = true;
    }
  });
};

document.querySelectorAll(".element-businessunitdivisions").forEach((el) => {
  const container = el.querySelector(".divisions-slider .swiper");

  new Swiper(container, {
    modules: [A11y, Navigation],
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    speed: 500,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1536: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  const divisionsList = el.querySelector(".divisions-list");
  const divisionsItems = el.querySelector(".divisions-items");

  const prev = el.querySelector(".divisions-list-prev");
  const next = el.querySelector(".divisions-list-next");

  divisionsList.addEventListener("scroll", () => {
    setTimeout(() => {
      handleScollers();
    }, 250);
  });

  prev.addEventListener("click", () => {
    const selected = divisionsItems.querySelector("[aria-selected]");
    divisionsList.scrollLeft -= selected.offsetWidth;

    setTimeout(() => {
      handleScollers();
    }, 250);
  });

  next.addEventListener("click", () => {
    const selected = divisionsItems.querySelector("[aria-selected]");
    divisionsList.scrollLeft += selected.offsetWidth;

    setTimeout(() => {
      handleScollers();
    }, 250);
  });
});

on("businessunitdivisions:activate", "html", (e) => {
  const tabpanel = e.detail;
  const element = tabpanel.closest(".element-businessunitdivisions");
  const popoverMenu = element.querySelector(".divisions-popover-menu");
  const nav = element.querySelector(".divisions-nav");

  const selectedPopoverItem = popoverMenu.querySelector(`[role="tab"][aria-controls="${tabpanel.id}"]`);
  popoverMenu.querySelector("span").textContent = selectedPopoverItem.textContent;

  nav.querySelectorAll('[role="tab"]').forEach((x) => x.setAttribute("aria-selected", false));

  element.querySelectorAll('[role="tabpanel"]').forEach((x) => x.setAttribute("aria-hidden", true));
  tabpanel.setAttribute("aria-hidden", false);

  nav
    .querySelectorAll(`[role="tab"][aria-controls="${tabpanel.id}"]`)
    .forEach((x) => x.setAttribute("aria-selected", true));

  const filterPills = nav.querySelector("[data-pill-list]");

  if (filterPills) {
    setTimeout(() => {
      pillList.animatePillMarker(filterPills);
      nav
        .querySelector(`[data-pill][aria-selected="true"]`)
        .scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    });
  }
});

on("click", ".divisions-popover-menu a", (e) => {
  e.preventDefault();

  const tabpanel = document.getElementById(e.currentTarget.getAttribute("aria-controls"));

  fire(document.documentElement, "businessunitdivisions:activate", tabpanel);
});

on("click", ".division-open", (e) => {
  const element = e.target.closest(".element-businessunitdivisions");
  const slider = element.querySelector(".divisions-slider");
  const nav = element.querySelector(".divisions-nav");
  const content = element.querySelector(".divisions-content");

  const targetDivision = e.currentTarget.dataset.division;
  const tabpanel = document.getElementById(`division-panel-${targetDivision}`);

  fire(document.documentElement, "businessunitdivisions:activate", tabpanel);

  slider.classList.add("hidden");
  nav.classList.remove("hidden");
  content.classList.remove("hidden");

  handleScollers();
});

on("click", ".division-close", (e) => {
  const element = e.target.closest(".element-businessunitdivisions");
  const slider = element.querySelector(".divisions-slider");
  const nav = element.querySelector(".divisions-nav");
  const content = element.querySelector(".divisions-content");

  nav.classList.add("hidden");
  content.classList.add("hidden");
  slider.classList.remove("hidden");
});

on("click", ".division-website-link", (e) => {
  e.stopPropagation();

  return false;
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    handleScollers();
  }, 250);
});
